import { render, staticRenderFns } from "./BasePhoneNumberInput.vue?vue&type=template&id=40fd6d0e&scoped=true&"
import script from "./BasePhoneNumberInput.vue?vue&type=script&lang=ts&"
export * from "./BasePhoneNumberInput.vue?vue&type=script&lang=ts&"
import style0 from "./BasePhoneNumberInput.vue?vue&type=style&index=0&id=40fd6d0e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fd6d0e",
  null
  
)

export default component.exports